import apiSlice from './ApiSlice';

export const followUpApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
      // Get FollowUp Filter Pagination
   getFollowUpPagination : builder.query({ 
    providesTags:['followup'] ,
      query: (body) => {
        return {
          url: '/followup',
          method: 'POST',
          body,
        };
      },
    }), 
     // ADD
     addFollowUp: builder.mutation({  
        invalidatesTags: ["followup"],
        query: (body) => {
          return {
            url: "/followup/add",
            method: "POST",
            body,
          };
        },
      }), 
        // EDIT
    editFollowUp: builder.mutation({
        invalidatesTags: ["followup"],
        query: ({ body, id }) => {
          return {
            url: `/followup/${id}`,
            method: "PUT",
            body,
          };
        },
      }),
      // GET SINGLE 
      getFollowUpById: builder.query({
        providesTags: ["followup"],
        query: ({ id }: { id: string }) => {
          return {
            url: `/followup/${id}`,
            method: "GET",
          };
        },
      }), 
       // Get  All Pending FollowUp Filter Pagination
   getAllPendingFollowUp : builder.query({ 
    providesTags:['followup'] ,
      query: (body) => {
        return {
          url: '/todays-followups',
          method: 'POST',
          body,
        };
      },
    }), 

       // GET All Pending Followup  Count
       getPendingFollowupCount: builder.query({
        providesTags: ["followup"],
        query: () => {
          return {
            url: `/todays-followups/get-pending-followup-count`,
            method: "GET",
          };
        },
      }),

  }),
});

export const { useGetFollowUpPaginationQuery , useAddFollowUpMutation , useEditFollowUpMutation , useGetFollowUpByIdQuery , useGetAllPendingFollowUpQuery , useGetPendingFollowupCountQuery } = followUpApi;
